import { signInWithPopup, AuthProvider } from "firebase/auth";
import { auth, googleProvider, facebookProvider } from "../config/firebase.config";
import { Constants } from "../constants/constants";

class SocialAuthService {
  API: string;

  constructor() {
    this.API = process.env.REACT_APP_SOCIAL_AUTH_ENDPOINT || '';
  }

  async signInWithProvider(provider: AuthProvider) {
    try {
      const result = await signInWithPopup(auth, provider);
      const idToken = await result.user.getIdToken();

      const response = await fetch(this.API, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ idToken }),
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          type: 'error',
          result: { message: data?.message || Constants.DEFAULT_ERROR_MESSAGE },
          status: response.status,
        } as const;
      }

      return { type: 'success', result: data };
    } catch (error: any) {
      if (error?.code?.startsWith('auth/')) {
        throw error;
      }

      return {
        type: 'error',
        result: { message: Constants.DEFAULT_ERROR_MESSAGE },
      } as const;
    }
  }

  async signInWithGoogle() {
    return this.signInWithProvider(googleProvider);
  }

  async signInWithFacebook() {
    return this.signInWithProvider(facebookProvider);
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new SocialAuthService();